module.exports = __webpack_public_path__ + "static/media/sourceIcon.7c7aeace.svg";